import { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import axiosInstance from '../../services/axiosInterceptor';
import UploadImage from './UploadImage';
import axios from 'axios';
import * as EmailValidator from 'email-validator';
import ReCAPTCHA from 'react-google-recaptcha';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { useHistory } from 'react-router-dom';
import { language } from '../../language';
import {
    FormattedMessage,
    useIntl,
    defineMessage,
    IntlProvider
} from 'react-intl';

const BugReportPage = () => {
    const [email, setEmail] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState(null);
    const [isVerified, setIsVerifed] = useState(false);
    const [descriptionErrorMessage, setDescriptionErrorMessage] =
        useState(null);
    const [file, setFile] = useState([]);
    let history = useHistory();
    const intl = useIntl();
    const messages = defineMessage({
        invalidEmailFormat: {
            id: 'Report.invalidEmailFormat',
            defaultMessage: 'Invalid Email Format'
        },
        desTooShort: {
            id: 'Report.desTooShort',
            defaultMessage: 'Description too short'
        }
    });

    useEffect(() => {
        console.log(file);
    }, [file]);

    const [description, setDescription] = useState('');
    const onReCAPTCHAVerified = () => {
        setIsVerifed(true);
    };
    const setAndCheckEmail = (e) => {
        setEmailErrorMessage(null);
        setEmail(e.target.value);
        if (!EmailValidator.validate(e.target.value)) {
            setEmailErrorMessage(
                intl.formatMessage(messages.invalidEmailFormat)
            );
        }
    };

    const setAndCheckDescription = (e) => {
        setDescriptionErrorMessage(null);
        setDescription(e.target.value);
        if (description.length < 50) {
            setDescriptionErrorMessage(
                intl.formatMessage(messages.desTooShort)
            );
        }
    };

    const onSubmit = async () => {
        setEmailErrorMessage('');
        setDescriptionErrorMessage('');

        if (!EmailValidator.validate(email)) {
            setEmailErrorMessage(
                intl.formatMessage(messages.invalidEmailFormat)
            );
            return;
        }
        if (description.length < 50) {
            setDescriptionErrorMessage(
                intl.formatMessage(messages.desTooShort)
            );
            return;
        }
        const urls = [];
        try {
            for (let f of file) {
                const uploadConfig = await axiosInstance().post(
                    'report/upload',
                    {
                        name: f.name,
                        type: f.type
                    }
                );
                urls.push(uploadConfig.data.key);
                await axios.put(uploadConfig.data.url, f, {
                    headers: {
                        'Content-Type': f.type
                    }
                });
            }
            await axiosInstance().post('report/add-report', {
                email: email,
                description: description,
                urls: urls
            });
        } catch (err) {
            console.log(err);
        } finally {
            setEmail('');
            setDescription('');
            setFile([]);
            setIsVerifed(false);
        }

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <IntlProvider locale={language}>
                        <Card
                            style={{ width: '25rem' }}
                            className="confirmCard"
                        >
                            <Card.Body>
                                <Card.Title>
                                    <FormattedMessage
                                        id="Report.thankyouTitle"
                                        defaultMessage="Thank you"
                                    />
                                </Card.Title>
                                <Card.Text>
                                    <FormattedMessage
                                        id="Report.thankyouContent"
                                        defaultMessage="We have received your feedback, thank you very much"
                                    />
                                </Card.Text>
                                <Container fluid>
                                    <Row>
                                        <Col xs={6} className="text-left">
                                            <Button
                                                variant="outline-success"
                                                className="w-100"
                                                onClick={() => {
                                                    history.push('/survey');
                                                    onClose();
                                                }}
                                            >
                                                OK
                                            </Button>
                                        </Col>
                                    </Row>
                                </Container>
                            </Card.Body>
                        </Card>
                    </IntlProvider>
                );
            }
        });
        function sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        }
        sleep(3000).then(() => {
            history.push('/survey');
        });
    };
    return (
        <Container>
            <Row>
                <Col>
                    <p className="h4">
                        <FormattedMessage
                            id="Report.title"
                            defaultMessage="Bug Report Page"
                        />
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form>
                        <Form.Group
                            controlId="formBasicEmail"
                            className="text-left mt-2"
                        >
                            <Form.Label>
                                <FormattedMessage
                                    id="Report.emailPrompt"
                                    defaultMessage="Please enter your email below to confirm:"
                                />
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={email}
                                isInvalid={emailErrorMessage}
                                placeholder="Enter your email here"
                                onChange={setAndCheckEmail}
                            />
                            <Form.Control.Feedback type="invalid">
                                {emailErrorMessage}
                            </Form.Control.Feedback>
                            <Form.Label className="mt-3">
                                <FormattedMessage
                                    id="Report.desPrompt"
                                    defaultMessage="Please describe the bug you found: (no less than 50 characters)"
                                />
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={description}
                                isInvalid={descriptionErrorMessage}
                                placeholder="Please describe the bug"
                                onChange={setAndCheckDescription}
                            />
                            <Form.Control.Feedback type="invalid">
                                {descriptionErrorMessage}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
            <Row>
                <Col>
                    <UploadImage file={file} setFile={setFile} />
                </Col>
            </Row>
            <Row>
                <Col
                    xs={{ span: 6, offset: 3 }}
                    className="d-flex justify-content-center"
                >
                    <ReCAPTCHA
                        sitekey="6LcNyPAbAAAAAMvXbdsIOkMvxGATbhG5BvAYLsSj"
                        onChange={onReCAPTCHAVerified}
                    />
                </Col>
            </Row>
            <Row className="mt-4 mb-4">
                <Col>
                    <Button
                        variant="outline-success"
                        size="lg"
                        disabled={
                            !isVerified ||
                            !email ||
                            !description ||
                            emailErrorMessage ||
                            descriptionErrorMessage
                        }
                        onClick={onSubmit}
                    >
                        <FormattedMessage
                            id="Report.action"
                            defaultMessage="Submit bug report"
                        />
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default BugReportPage;
